// session state key
export const AURR_STATE_STORAGE_KEY = 'aurrState';
